// multiSelect styles
export const multiSelectStyles = `margin: 1rem;
                          .option:hover {
                                background-color: #318616 !important;
                           }
                          .searchWrapper {
                                background-color: white !important;
                          }
                         `;
